import { ConversationReservedLogEntry } from 'lib-shared-legacy-types';

import { ConversationTimestamp } from 'components/conversation/components/conversationTimestamp/conversationTimestamp';

import { LogEntry } from './logEntry';
import { QueueLink } from './queueLink/queueLink';
import { UserLink } from './userLink/userLink';

type ConversationReservedProps = {
  entry: ConversationReservedLogEntry;
};

export const ConversationReserved = ({
  entry,
}: ConversationReservedProps): JSX.Element => {
  const { agent } = entry;

  const agentLink = (
    <UserLink userId={agent.id}>{agent.name ?? agent.id}</UserLink>
  );

  const queueLink = (
    <QueueLink queueId={entry.queue_id}>{entry.queue_name}</QueueLink>
  );

  const validUntil = (
    <ConversationTimestamp
      time={entry.valid_until}
      isSecondsDisplayed={false}
      textProps={{
        as: 'span',
        variant: '3',
        subdued: false,
      }}
    />
  );

  const formatReason = (reason: string): string => {
    switch (reason) {
      case 'FOLLOW_UP':
        return 'follow-up';
      case 'LAST_AGENT':
        return 'last agent';
      case 'PREFERRED_AGENT':
        return 'preferred agent';
      default:
        return 'unknown';
    }
  };

  return (
    <LogEntry
      entry={entry}
      text={
        <>
          Conversation is reserved for {agentLink} in {queueLink} until{' '}
          {validUntil} with reason: {formatReason(entry.reservation_type)}
        </>
      }
    />
  );
};
